import { useState } from 'react';

interface DialogState<T = string> {
    isOpen: boolean;
    data: T | null;
}

export const useDialogState = <T = string>() => {
    const [state, setState] = useState<DialogState<T>>({
        isOpen: false,
        data: null,
    });

    const open = (data: T) => {
        setState({ isOpen: true, data });
    };

    const close = () => {
        setState({ isOpen: false, data: null });
    };

    return {
        isOpen: state.isOpen,
        data: state.data,
        open,
        close,
    };
};
